import { render } from "./email.vue?vue&type=template&id=5c1084d5&scoped=true"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"

import "./email.vue?vue&type=style&index=0&id=5c1084d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1084d5"]])

export default __exports__